import { Injectable, isDevMode } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoggingService {
  constructor() {}

  logDebug(...data: any[]) {
    if (isDevMode()) {
      console.log(data);
    }
  }
}
